// ============================================================
// 피부 타입별 제품 데이터
// 이 파일만 수정하면 사이트에 바로 반영돼요!
//
// 각 제품 항목 구성:
//   name   : 제품명
//   tag    : 카테고리 (토너, 세럼, 크림 등)
//   price  : 가격대
//   link   : 올리브영 큐레이터 링크
//   desc   : 한줄 설명
//   reason : 이 피부타입에 추천하는 이유
//
// ※ 피부 타입별로 풀에서 랜덤 3개가 노출됩니다.
// ============================================================

const PRODUCTS = {

  // ──────────────────────
  // 🌙 건성 피부
  // ──────────────────────
  dry: [
    {
      name: "바이오더마 센시비오 H2O 클렌징 워터",
      tag: "클렌저", price: "18,000원~", link: "https://oy.run/1fzGFlkeFF26zF",
      desc: "자극 없이 부드럽게 세정해 건조함을 최소화해줘요",
      reason: "세안 자체가 피부를 건조하게 만드는 주범이에요. 저자극 클렌저로만 바꿔도 건조함이 눈에 띄게 줄어들어요.",
    },
    {
      name: "닥터자르트 세라마이딘 스킨 베리어 모이스처라이징 크림",
      tag: "크림", price: "48,000원~", link: "https://oy.run/KVBYHNX283xqCI",
      desc: "세라마이드로 피부 장벽을 탄탄하게 채워줘요",
      reason: "각질층 사이사이를 채워주는 세라마이드 성분이 수분 증발을 막아줘요. 각질이 자주 일어나는 분께 특히 효과적이에요.",
    },
    {
      name: "에스트라 아토베리어 365 로션",
      tag: "로션", price: "25,000원~", link: "https://oy.run/hB4rDYd6A85ot9",
      desc: "피부 장벽을 강화하고 건조함을 오래 막아줘요",
      reason: "세라마이드 성분이 수분 손실을 방지하고 건조한 피부를 촉촉하게 유지시켜줘요. 가볍게 발리면서도 보습력이 뛰어나요.",
    },
    {
      name: "피지오겔 DMT 페이셜 크림",
      tag: "보습크림", price: "28,000원~", link: "https://oy.run/rhBghzdEjTQWfY",
      desc: "건성 피부 전용 장벽 강화 보습 크림이에요",
      reason: "피부과에서도 추천하는 건성 피부 전용 크림이에요. 유수분 밸런스를 맞추면서 건조함을 오래 케어해줘요.",
    },
    {
      name: "토리든 다이브인 저분자 히알루론산 토너",
      tag: "토너", price: "19,000원~", link: "https://oy.run/wkXZhYOxR8VeWl",
      desc: "저분자 히알루론산으로 피부 깊이 수분을 채워줘요",
      reason: "가볍게 흡수되면서 즉각적인 수분감을 줘요. 건성 피부 기초 루틴 첫 단계로 딱 맞아요.",
    },
    {
      name: "코스알엑스 더 히알루론산 3 세럼",
      tag: "세럼", price: "22,000원~", link: "https://oy.run/7nmonkLW6b2W3D",
      desc: "3중 히알루론산으로 피부 속 수분을 깊이 채워줘요",
      reason: "분자 크기가 다른 히알루론산이 피부 표면부터 깊은 층까지 수분을 채워줘요. 건성 피부 세럼 단계로 효과적이에요.",
    },
    {
      name: "아누아 어성초 77 히알루론산 수분 진정 토너",
      tag: "토너", price: "18,000원~", link: "https://oy.run/yrhwaMG4rmwp7p",
      desc: "어성초와 히알루론산으로 수분을 채우고 피부를 진정시켜줘요",
      reason: "건성 피부는 수분 부족으로 예민해지기 쉬워요. 수분 공급과 진정을 동시에 해주는 토너예요.",
    },
    {
      name: "달바 화이트 트러플 퍼스트 스프레이 세럼",
      tag: "세럼", price: "35,000원~", link: "https://oy.run/8cdmxMIqe3chBF",
      desc: "트러플 성분으로 피부에 윤기와 수분을 더해줘요",
      reason: "건성 피부에 필요한 고보습과 영양을 동시에 공급해줘요. 스프레이 타입이라 기초 전후 언제든 편하게 쓸 수 있어요.",
    },
  ],

  // ──────────────────────
  // ✨ 지성 피부
  // ──────────────────────
  oily: [
    {
      name: "이니스프리 수퍼 화산송이 모공 마스크",
      tag: "마스크팩", price: "18,000원~", link: "https://oy.run/jMATpKnjVyqxXv",
      desc: "화산송이로 과잉 피지를 흡착해 모공을 깨끗하게 해줘요",
      reason: "제주 화산송이의 다공성 구조가 피지와 노폐물을 빨아들여요. 주 1~2회 사용으로 번들거림이 눈에 띄게 줄어들어요.",
    },
    {
      name: "닥터지 레드블레미쉬 클리어 수딩크림EX",
      tag: "수분크림", price: "26,000원~", link: "https://oy.run/u7OBgzy3X6l1X9",
      desc: "지성 피부도 촉촉하게, 트러블 케어까지 한번에",
      reason: "기름기 없이 산뜻하게 흡수되면서도 수분막은 유지시켜줘요. 피지 분비 억제에 도움 되는 성분이 포함돼 있어요.",
    },
    {
      name: "조선미녀 맑은쌀 선크림",
      tag: "선크림", price: "15,000원~", link: "https://oy.run/sA3pBsQg9nK5Uf",
      desc: "쌀 성분으로 가볍고 산뜻하게 밀착되는 선크림이에요",
      reason: "백탁 없이 얇게 발리고 번들거림이 없어요. 지성 피부가 선크림을 꺼리는 이유가 사라지는 제품이에요.",
    },
    {
      name: "라운드랩 1025 독도 토너",
      tag: "토너", price: "19,000원~", link: "https://oy.run/PmIsI3I0yN3Pr1",
      desc: "피지는 조절하고 수분은 가볍게 채워줘요",
      reason: "해양심층수 성분이 지성 피부의 유수분 밸런스를 잡아줘요. 가볍게 흡수되어 번들거림 없이 촉촉함을 유지해줘요.",
    },
    {
      name: "토리든 다이브인 저분자 히알루론산 토너",
      tag: "토너", price: "19,000원~", link: "https://oy.run/wkXZhYOxR8VeWl",
      desc: "끈적임 없이 가볍게 수분을 보충해줘요",
      reason: "지성 피부도 수분이 부족하면 피지가 더 분비돼요. 가벼운 수분 공급으로 피지 과잉 분비를 줄여줘요.",
    },
    {
      name: "아누아 어성초 77 히알루론산 수분 진정 토너",
      tag: "토너", price: "18,000원~", link: "https://oy.run/yrhwaMG4rmwp7p",
      desc: "어성초 성분으로 피지를 진정시키고 수분을 채워줘요",
      reason: "어성초 77%로 트러블과 피지를 동시에 케어해줘요. 지성 피부의 번들거림을 줄이면서 촉촉함을 유지시켜줘요.",
    },
    {
      name: "이니스프리 노세범 AC 파우더",
      tag: "파우더", price: "12,000원~", link: "https://oy.run/yyagFdZsjUQ6Id",
      desc: "피지 흡착 파우더로 하루 종일 번들거림을 잡아줘요",
      reason: "지성 피부의 최대 고민인 낮 시간 번들거림을 효과적으로 잡아줘요. 가볍게 눌러주는 것만으로도 깔끔하게 마무리돼요.",
    },
  ],

  // ──────────────────────
  // ☯️ 복합성 피부
  // ──────────────────────
  combo: [
    {
      name: "라운드랩 1025 독도 토너",
      tag: "토너", price: "19,000원~", link: "https://oy.run/PmIsI3I0yN3Pr1",
      desc: "T존 피지 조절과 U존 보습을 동시에 잡아줘요",
      reason: "독도 해양심층수 성분이 유수분 균형을 맞춰줘요. 복합성 피부의 부위별 불균형을 한 제품으로 잡을 수 있어요.",
    },
    {
      name: "차앤박 프로폴리스 에너지 액티브 앰플",
      tag: "앰플", price: "35,000원~", link: "https://oy.run/fLfee8q9wxOhRm",
      desc: "피부 진정과 보습을 함께 케어해줘요",
      reason: "프로폴리스가 피부 컨디션을 고르게 만들어줘요. 부위별로 피부결이 달라 보이는 복합성 피부에 균형감을 줘요.",
    },
    {
      name: "이니스프리 그린티 씨드 히알루론산 수분 세럼",
      tag: "세럼", price: "25,000원~", link: "https://oy.run/VgH0fecUYzW8jF",
      desc: "가볍게 흡수되며 유수분 밸런스를 잡아줘요",
      reason: "묽은 텍스처라 지성인 T존에도 무겁지 않아요. 복합성 피부 전체에 고르게 쓸 수 있는 세럼이에요.",
    },
    {
      name: "닥터지 레드 블레미쉬 클리어 히알 시카 수딩 세럼",
      tag: "세럼", price: "28,000원~", link: "https://oy.run/Q48ihVUt3ef4mO",
      desc: "히알루론산과 시카 성분으로 밸런스를 케어해줘요",
      reason: "T존 트러블은 진정하고 건조한 U존엔 수분을 공급해줘요. 복합성 피부의 양쪽 고민을 한번에 해결해줘요.",
    },
    {
      name: "아누아 어성초 77 히알루론산 수분 진정 토너",
      tag: "토너", price: "18,000원~", link: "https://oy.run/yrhwaMG4rmwp7p",
      desc: "T존 트러블 진정과 U존 수분 케어를 동시에 해줘요",
      reason: "어성초 성분이 피지 많은 부위는 진정시키고, 히알루론산이 건조한 부위엔 수분을 채워줘요. 복합성 피부에 딱 맞아요.",
    },
    {
      name: "토리든 다이브인 저분자 히알루론산 토너",
      tag: "토너", price: "19,000원~", link: "https://oy.run/wkXZhYOxR8VeWl",
      desc: "끈적임 없이 T존과 U존 모두 가볍게 수분을 채워줘요",
      reason: "가볍게 흡수돼 T존에 부담 없이 쓸 수 있어요. 건조한 U존에도 충분한 수분을 공급해줘요.",
    },
    {
      name: "코스알엑스 살리실산 데일리 젠틀 클렌저",
      tag: "클렌저", price: "16,000원~", link: "https://oy.run/CLKSuAIA0aoaS3",
      desc: "살리실산 성분으로 T존 피지와 모공을 부드럽게 케어해줘요",
      reason: "복합성 피부의 T존 피지와 모공을 세안 단계부터 관리해줘요. 피부 자극 없이 매일 쓸 수 있는 순한 클렌저예요.",
    },
    {
      name: "닥터지 브라이트닝 업 선 플러스",
      tag: "선크림", price: "22,000원~", link: "https://oy.run/6gSihMusUbYN3w",
      desc: "가볍고 산뜻하게 발리는 복합성 피부용 선크림이에요",
      reason: "T존에 번들거림 없이 산뜻하게 밀착되고 건조한 부위도 들뜨지 않아요. 복합성 피부에 균형 잡힌 선크림이에요.",
    },
    {
      name: "달바 화이트 트러플 퍼스트 스프레이 세럼",
      tag: "세럼", price: "35,000원~", link: "https://oy.run/8cdmxMIqe3chBF",
      desc: "트러플 성분으로 유수분 밸런스를 고르게 맞춰줘요",
      reason: "스프레이 타입이라 건조한 부위에만 집중적으로 더 뿌려 쓸 수 있어요. 복합성 피부의 부위별 케어에 유용해요.",
    },
  ],

  // ──────────────────────
  // 🌸 민감성 피부
  // ──────────────────────
  sensitive: [
    {
      name: "닥터자르트 시카페어 인텐시브 수딩 리페어 크림",
      tag: "진정크림", price: "35,000원~", link: "https://oy.run/thVtEz8hu1ivL8",
      desc: "민감하고 손상된 피부 장벽을 빠르게 진정시켜줘요",
      reason: "판테놀과 시카 성분이 예민해진 피부를 빠르게 안정시켜요. 자극받은 다음 날 집중 케어로 쓰기 좋아요.",
    },
    {
      name: "에스트라 아토베리어 365 크림",
      tag: "수분크림", price: "28,000원~", link: "https://oy.run/tnqAcweVsfgjiQ",
      desc: "피부과 추천 성분으로 민감한 피부 장벽을 강화해줘요",
      reason: "세라마이드와 판테놀이 손상된 피부 장벽을 채워줘요. 향료·자극 성분 없이 민감성 피부도 매일 쓸 수 있어요.",
    },
    {
      name: "라운드랩 자작나무 수분크림",
      tag: "수분크림", price: "22,000원~", link: "https://oy.run/e4Q0IDPAhlfHaw",
      desc: "저자극 포뮬라로 예민한 피부도 안심이에요",
      reason: "향료·알코올·인공색소 無첨가 포뮬라예요. 자작나무 수분 성분 기반으로 진정에 특화돼 있어요.",
    },
    {
      name: "바이오더마 센시비오 디펜시브 리치",
      tag: "진정크림", price: "32,000원~", link: "https://oy.run/0ulBbNEDydT3EI",
      desc: "민감하고 붉은 피부를 집중적으로 진정시켜줘요",
      reason: "피부 붉음증 완화에 특화된 성분이 들어있어요. 자극에 반응해 쉽게 빨개지는 민감성 피부에 잘 맞아요.",
    },
    {
      name: "에스트라 아토베리어 365 로션",
      tag: "로션", price: "25,000원~", link: "https://oy.run/hB4rDYd6A85ot9",
      desc: "민감한 피부 장벽을 부드럽게 강화해줘요",
      reason: "크림보다 가볍게 발려 민감성 피부에 부담이 없어요. 세라마이드 성분으로 장벽을 강화하면서 자극을 최소화해줘요.",
    },
    {
      name: "달바 화이트 트러플 퍼스트 스프레이 세럼",
      tag: "세럼", price: "35,000원~", link: "https://oy.run/8cdmxMIqe3chBF",
      desc: "자극 없이 피부에 촉촉함과 진정을 동시에 줘요",
      reason: "스프레이 타입이라 손으로 문지르지 않아도 되어 민감성 피부에 자극이 적어요. 순한 성분으로 예민한 피부도 편하게 쓸 수 있어요.",
    },
    {
      name: "아누아 어성초 77 히알루론산 수분 진정 토너",
      tag: "토너", price: "18,000원~", link: "https://oy.run/yrhwaMG4rmwp7p",
      desc: "어성초 성분으로 예민한 피부를 진정시키고 수분을 채워줘요",
      reason: "자극받은 민감성 피부를 어성초로 빠르게 진정시켜줘요. 히알루론산으로 수분도 동시에 채워줘요.",
    },
    {
      name: "라로슈포제 시카플라스트 밤 B5",
      tag: "진정크림", price: "32,000원~", link: "https://oy.run/RPwBxVOs4qQvXT",
      desc: "손상된 피부 장벽을 빠르게 복구하고 진정시켜줘요",
      reason: "판테놀과 마데카소사이드 성분이 손상된 피부 장벽을 집중 복구해줘요. 민감성 피부의 응급 케어로 검증된 제품이에요.",
    },
    {
      name: "토리든 다이브인 저분자 히알루론산 수딩 크림",
      tag: "크림", price: "23,000원~", link: "https://oy.run/dHLrwCCbUDiBCU",
      desc: "저분자 히알루론산으로 민감한 피부를 촉촉하게 진정시켜줘요",
      reason: "자극 없는 순한 성분으로 예민한 피부에 수분을 깊이 채워줘요. 가볍게 흡수돼 민감성 피부에 부담이 없어요.",
    },
  ],

  // ──────────────────────
  // 🌟 정상 피부
  // ──────────────────────
  normal: [
    {
      name: "코스알엑스 어드밴스드 스네일 96 뮤신 파워 에센스",
      tag: "에센스", price: "25,000원~", link: "https://oy.run/WWRPFD6guHpsfq",
      desc: "달팽이 뮤신으로 피부 탄력과 윤기를 더해줘요",
      reason: "정상 피부의 좋은 상태를 유지하면서 탄력까지 챙길 수 있어요. 해외에서도 극찬받는 가성비 에센스예요.",
    },
    {
      name: "아이소이 브라이트닝 카밍 스팟 세럼",
      tag: "세럼", price: "25,000원~", link: "https://oy.run/dGBrmsRjr50aAX",
      desc: "피부 톤을 고르게 정돈하고 광채를 더해줘요",
      reason: "나이아신아마이드 성분이 정상 피부의 칙칙함을 개선해줘요. 현재 좋은 피부를 더 빛나게 만들어주는 세럼이에요.",
    },
    {
      name: "토리든 다이브인 저분자 히알루론산 크림",
      tag: "크림", price: "25,000원~", link: "https://oy.run/FqJyhMNmv0g9kK",
      desc: "가볍게 흡수되며 촉촉한 피부를 유지시켜줘요",
      reason: "과하지 않은 보습감이 정상 피부의 밸런스를 흐트러뜨리지 않아요. 산뜻하면서도 촉촉함이 오래 유지돼요.",
    },
    {
      name: "달바 화이트 트러플 퍼스트 스프레이 세럼",
      tag: "세럼", price: "35,000원~", link: "https://oy.run/8cdmxMIqe3chBF",
      desc: "트러플 성분으로 피부에 윤기와 광채를 더해줘요",
      reason: "정상 피부의 좋은 컨디션을 더욱 빛나게 업그레이드해줘요. 기초 전후 언제든 편하게 추가할 수 있어요.",
    },
    {
      name: "조선미녀 맑은쌀 채운 토너",
      tag: "토너", price: "18,000원~", link: "https://oy.run/RMlDW8sfARX4UH",
      desc: "쌀 성분으로 피부결을 매끄럽고 환하게 정돈해줘요",
      reason: "쌀 발효 성분이 피부 결을 고르게 만들고 광채를 더해줘요. 정상 피부의 좋은 컨디션을 유지하는 데 딱이에요.",
    },
    {
      name: "토리든 다이브인 저분자 히알루론산 토너",
      tag: "토너", price: "19,000원~", link: "https://oy.run/wkXZhYOxR8VeWl",
      desc: "가볍게 수분을 채워 피부 컨디션을 유지해줘요",
      reason: "정상 피부에 과하지 않게 수분을 보충해줘요. 가볍게 흡수되어 밸런스를 유지하는 데 최적이에요.",
    },
  ],
};

export default PRODUCTS;
